<script>
import * as XLSX from 'xlsx'
 export default{
    data:{
    }
    ,methods:{
        fnCreateExcelColumn:function(colToExcel){
           let obj = {};
           let str = "";
           let makerow = new Object();
           if(colToExcel != null){
              let column = colToExcel.split(",");
              if(column.length > 0){
                  for(let i=0; i<column.length; i++){
                      let item = column[i];
                      let objcol = (i<10) ? '0' + i : i;
                      str = 'excel_' + objcol;
                      makerow[str] = item;
                  }
              }
           }
           return makerow;
        }
        ,fnUpdateExcelColumn:function(dataArray, columnArray){

             let _columnArray = Object.keys(columnArray);
             const korean = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;
             let _data = [];


            for(let i=0; i<dataArray.length; i++){
                let item = dataArray[i];
                let _dataObject = Object.keys(item);

                    for(let idx in _dataObject){
                        let _datakey = _dataObject[idx];
                        for(let idxs in _columnArray){

                            let _columnkey = _columnArray[idxs];

                            if( _datakey === _columnkey){
                                    let oldKey = _dataObject[idx];
                                    let newKey = columnArray[oldKey];
                                    dataArray[i][ newKey ] = dataArray[i][ oldKey ];
                                    delete dataArray[i][ oldKey ];
                                }
                        }

                        if(!korean.test(_datakey)){
                            delete dataArray[i][_datakey];
                        }
                }

            }
            //  dataArray.forEach(function(item, idxa ,arr){
            //     let _dataObject = Object.keys(item);
            //      for(let idxs in _columnArray){
            //          for(let idx in _dataObject){
            //             let _datakey = _dataObject[idx];
            //             let _columnkey = _columnArray[idxs];

            //             if( _datakey === _columnkey){
            //                     let oldKey = _dataObject[idx];
            //                     let newKey = columnArray[oldKey];
            //                     item[ newKey ] = item[ oldKey ];
            //                     delete item[ oldKey ];

            //             }
            //         }
            //     }
            //  });
             return dataArray;
        }
        ,fnOnClickExcelDownload:function(dataArray, columnArray, _sheetName, _downloadName){
            if(dataArray.length == 0 || columnArray.length == 0){
                alert("다운로드 할 데이터가 없습니다.");
                return;
            }
            let _convertExcel = this.fnUpdateExcelColumn(dataArray, columnArray);
            if(_convertExcel.length > 0){
                  const workSheet = XLSX.utils.json_to_sheet(_convertExcel);
                  const workBook = XLSX.utils.book_new()
                 XLSX.utils.book_append_sheet(workBook, workSheet, _sheetName)
                 XLSX.writeFile(workBook, _downloadName+'.xlsx')
            }
        }
        , fnOnClickExcelDownloadWithTable:function(){

        }
    }

  }
</script>
